import AccountSidebar from './AccountSidebar'
import Footer from '/web/shared/aifans/Footer'
import HeaderContainer from '/web/shared/aifans/HeaderContainer'
import { Title, Meta } from '@solidjs/meta'

export default function DmcaPolicy() {
  return (
    <>
      <Title>CosplayFans - DMCA Policy | Copyright Protection & Reporting</Title>
      <Meta
        name="og:title"
        content="CosplayFans - DMCA Policy | Copyright Protection & Reporting"
      />
      <Meta
        name="description"
        content="Read CosplayFans.ai's DMCA Policy to learn how we handle copyright issues, report infringements, and protect original cosplay content and intellectual property."
      />
      <Meta
        name="og:description"
        content="Read CosplayFans.ai's DMCA Policy to learn how we handle copyright issues, report infringements, and protect original cosplay content and intellectual property."
      />
      <HeaderContainer />
      <main class="dmca-policy page-bg relative overflow-hidden bg-main pb-20 pt-20 font-normal sm:pt-28 md:bg-none md:pb-36">
        <div class="container relative z-20">
          <div class="wrapper gap-8 lg:flex">
            <AccountSidebar />

            {/* right */}
            <div class="right flex w-full flex-col">
              {/* head */}
              <div class="head gray-to-tran mb-7 rounded-xl text-[28px] font-semibold sm:p-4">
                <h2>DMCA Policy</h2>
              </div>

              <div class="content gray-to-tran  w-full rounded-xl sm:p-6">
                <div class="date text-base font-semibold">Date of Revision: [ 01/01/2024 ]</div>

                <p class="mt-[25px]">
                  CosplayFans.ai is committed to respecting the intellectual property rights of
                  others and is devoted to compliance with the Digital Millennium Copyright Act
                  (DMCA) and applicable copyright legislation. Our DMCA Policy outlines the measures
                  we implement to respond to claims of copyright infringement and offers
                  instructions for contacting us if you believe your copyrighted work has been used
                  on our platform without the necessary permission.
                </p>

                {/* list */}
                <ul class="list mt-[50px]">
                  <li>
                    <h3>1. Reporting Copyright Infringement</h3>

                    <p>
                      Should you, in earnest, suspect that content made available through
                      cosplay-fans.com (the &quot;App&quot;) violates your copyright, you or your
                      designated representative may send us a formal request for the removal of the
                      content or to restrict access to it. Kindly include the following details in
                      your written notification:
                    </p>

                    <p>
                      a. The signature, either electronic or physical, of the copyright owner or an
                      individual authorized to represent them;
                    </p>

                    <p>
                      b. A detailed description of the copyrighted work you believe has been
                      infringed, along with enough details for us to identify and locate the work;
                    </p>

                    <p>
                      c. Your contact information, including address, telephone number, and email
                      address;
                    </p>

                    <p>
                      d. A declaration from you indicating a bona fide belief that the contentious
                      usage of the material was not approved by the copyright owner, their agent, or
                      by law;
                    </p>

                    <p>
                      e. A formal statement by you, under the risk of perjury, affirming that the
                      information provided in your notification is accurate and that you are the
                      copyright owner or are duly authorized to act on their behalf.
                    </p>
                  </li>

                  <li>
                    <h3>2. DMCA Notices Response</h3>

                    <p>
                      Upon receipt of a fully detailed infringement notification, we will proceed as
                      follows:
                    </p>

                    <p>
                      a. Assess and verify that the provided documents comply with the requirements
                      set by the DMCA;
                    </p>

                    <p>
                      b. Initiate appropriate initial measures to address the reported infringement
                      within 1-3 days of receiving such notification, which may include, among other
                      actions, blocking access to the implicated links;
                    </p>

                    <p>
                      c. Contact the party accused of infringement, requesting their response and
                      submission of any opposing evidence.
                    </p>
                  </li>

                  <li>
                    <h3>3. Counter Notification</h3>

                    <p>
                      Should you sincerely think that a copyright infringement notice has been
                      mistakenly issued against you, you are welcome to submit a counter-notice to
                      us. Upon doing so, we will inform the claimant of your counter-claim and pause
                      the removal process for 10-14 days, during which time we will restore your
                      content unless the copyright owner commences legal proceedings against you
                      within that period.
                    </p>
                  </li>

                  <li>
                    <h3>4. Contact Information</h3>

                    <p>
                      Please direct all notices and counter-notices to our email address at
                      support@cosplay-fans.com. We are dedicated to resolving issues promptly and
                      providing a satisfactory experience for all users.
                    </p>
                  </li>

                  <li>
                    <h3>5. Termination</h3>

                    <p>
                      We reserve the authority to suspend or terminate access to the App for anyone
                      believed to be involved in the aforementioned infringement activities.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* bg */}
        <div class="radial-bg bottom-[-40%] left-[-250px] right-0 h-[1000px] w-[900px] opacity-10 md:hidden"></div>
      </main>
      <Footer />
    </>
  )
}
